"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.propIsNot = exports.propIs = void 0;
/**
 * Find all entires in an array where `prop` equals `value`.
 *
 * @param items The Items to filter
 * @param prop The property to filter
 * @param value The value to check for
 */
exports.propIs = (items, prop, value) => {
    return items.filter((item) => {
        return item[prop] === value;
    });
};
/**
 * Find all entires in an array where `prop` does not equals `value`.
 *
 * @param items The Items to filter
 * @param prop The property to filter
 * @param value The value to check for
 */
exports.propIsNot = (items, prop, value) => {
    return items.filter((item) => {
        return item[prop] !== value;
    });
};
//# sourceMappingURL=selectors.js.map